// Percorso file: src/pages/legal/LegalIndex.jsx
//
// L'ELENCO DEI DOCUMENTI DI UNA CATEGORIA (cantiere LEGAL-DOCS): la
// pagina di terzo livello che le due voci del contenitore «More /
// Assistance» (MorePage.jsx) aprono, con una voce per ogni documento di
// LEGAL_DOCS della categoria chiesta.
//
// UN COMPONENTE, DUE ROTTE: App.jsx lo monta su /legal con
// `category="legal"` e titolo «Legal & Privacy» (oggi il Privacy
// Statement) e su /terms con `category="terms"` e titolo «Terms &
// Conditions» (i cinque documenti del club). La categoria vive nel DATO
// (`category` di ogni documento, legalDocs.js), non nell'URL: le voci
// linkano tutte al visualizzatore condiviso /legal/<slug>, perché lo slug
// è unico fra tutti i documenti, di qualunque categoria.
//
// L'elenco si COSTRUISCE DAI DATI (`Object.values(LEGAL_DOCS)` filtrato
// per `category`): un documento nuovo si aggiunge in legalDocs.js con la
// sua categoria e compare da sé nell'elenco giusto, senza toccare questo
// file.
//
// La forma è quella dei menu delle home (HomeAdmin.jsx: `nav.qpsc-menu` +
// `button.qpsc-btn-gold` con `navigate(to)`, icona Font Awesome a
// sinistra — §5, regola tutto-o-niente) dentro il telaio comune, come la
// pagina-elenco HomeContext.jsx. Nessun CSS proprio: elenco e pulsanti
// sono del telaio.
//
// Il Back è «da dove si è venuti» (`navigate(-1)`), non `/home`: vedi la
// nota in LegalDocument.jsx. Il controllo d'accesso NON sta qui: sta in
// App.jsx, nel cancello condiviso RequireRole.

import React from "react";
import { useNavigate } from "react-router-dom";
import { FaFileAlt } from "react-icons/fa";
import HomeShell from "../../components/HomeShell";
import { LEGAL_DOCS } from "./legalDocs";

const LegalIndex = ({ category, title }) => {
  const navigate = useNavigate();
  const documenti = Object.values(LEGAL_DOCS).filter(
    (doc) => doc.category === category
  );

  return (
    <HomeShell backTo={() => navigate(-1)}>
      <h1 className="qpsc-page-title">{title}</h1>

      <nav className="qpsc-menu">
        {documenti.map(({ slug, title: titolo }) => (
          <button
            key={slug}
            type="button"
            className="qpsc-btn-gold"
            onClick={() => navigate("/legal/" + slug)}
          >
            <span className="qpsc-btn-gold__icon">
              <FaFileAlt />
            </span>
            {titolo}
          </button>
        ))}
      </nav>
    </HomeShell>
  );
};

export default LegalIndex;
